export enum ListingStatus {
  Active = 0,
  Suspended = 1,
  Sold = 2,
}
